<template lang="pug">
form
  .row
    .col-md-6
      .form-group
        Label(text="Name")
        Input(v-model="publication.name")
      .form-group
        Label(text="Slug")
        Input(v-model="publication.slug")
      .form-group
        Label(text="Account")
        Input(v-model="publication.account")

    .col-md-6
      .form-group
        Label(text="URL")
        Input(v-model="publication.url")
      .form-group
        Label(text="Foreign key")
        Input(v-model="publication.guid")
      .form-group
        Label(text="Key")
        Input(v-model="publication.key")

  .row
    .col-md-12
      h2 Show/hide options
      span.help-block Hide data from this publication as options in the story form

  .row
    .col-md-4
      .checkbox
        LabelledCheckbox(label="Hide story templates" v-model="publication.hide_story_templates")

    .col-md-4
      .checkbox
        LabelledCheckbox(label="Hide content types" v-model="publication.hide_content_types")

    .col-md-4
      .checkbox
        LabelledCheckbox(label="Hide bylines" v-model="publication.hide_bylines")

  .row
    .col-md-12
      hr
      Label(text="Notes")
      TextareaInput(v-model="publication.notes")
      br

  .row
    .col-md-12
      button.btn.btn-primary(type="button" @click="save") Save
      a.btn.btn-link.text-muted(href="/admin/publications") cancel
</template>

<script setup>
  import { getCurrentInstance, onBeforeMount } from 'vue'
  import { storeToRefs } from 'pinia'
  import { usePublicationStore } from '@/stores/publication'

  import Input from '@/components/shared/input.vue'
  import Label from '@/components/shared/label.vue'
  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue'
  import TextareaInput from '@/components/shared/textarea_input.vue'

  // TODO: this is how this should work in Vue 3. But in 2.7 we have to use the workaround below
  // import { useRouter } from 'vue-router';
  // const router = useRouter();
  const vm = getCurrentInstance().proxy;
  const router = vm.$router;

  const publicationStore = usePublicationStore()
  const { publication } = storeToRefs(publicationStore)

  const props = defineProps({
    publicationId: {
      type: Number,
      required: false
    }
  })

  if (props.publicationId) {
    onBeforeMount( async () => {
      await publicationStore.fetch({ publicationId: props.publicationId })
    })
  }

  const save = async () => {
    await publicationStore.save()
    router.push({ name: 'adminPublications' })
  }
</script>

<script>
  export default {
    // Because form is a reserved HTML tag
    name: 'publication-form'
  }
</script>
